import { AuthProviderProps } from "oidc-react";
import { getAppConfig } from "../config";

const appConfig = getAppConfig();
const redirectUri = (new URL('/signin', location.href)).toString()

export const oidcConfig: AuthProviderProps =  {
  authority: appConfig.identityServerUrl,
  clientId: appConfig.clientId,
  scope: appConfig.apiScope,
  redirectUri,
  loadUserInfo: true,
}